import { Link } from 'react-router-dom';
import { stats } from '@/mocks/features';
import { downloadLinks } from '@/mocks/about';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20flowing%20curves%20in%20coral%20red%20and%20warm%20amber%20tones%2C%20minimalist%20modern%20design%2C%20smooth%20organic%20shapes%2C%20cinematic%20atmosphere%2C%20soft%20diffused%20lighting%2C%20elegant%20and%20luxurious%20feel%2C%20no%20text%2C%20no%20sharp%20lines%2C%20digital%20art%20style&width=1600&height=900&seq=aiye-hero-bg&orientation=landscape"
          alt="爱液视频App背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="animate-fade-in-up">
          <span className="inline-block px-4 py-1.5 bg-primary-500/90 text-background-50 text-sm font-medium rounded-full mb-6 backdrop-blur-sm">
            <i className="ri-sparkling-line mr-1"></i>
            超过5000万用户的选择
          </span>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-6 leading-tight">
            爱液视频App
            <br />
            <span className="text-accent-400">海量高清 · 流畅体验</span>
          </h1>
          <p className="text-background-50/80 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
            汇聚电影、电视剧、综艺、动漫、纪录片等全品类内容，超过10万小时高清视频资源，智能推荐越用越懂你。随时随地，畅享精彩视频世界。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <a
              href={downloadLinks.android.url}
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
            >
              <i className="ri-android-line text-lg"></i>
              Android 下载
            </a>
            <a
              href={downloadLinks.ios.url}
              className="w-full sm:w-auto px-8 py-3.5 bg-background-50/20 text-background-50 border border-background-50/30 rounded-full text-base font-semibold hover:bg-background-50/30 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2 backdrop-blur-sm"
            >
              <i className="ri-apple-line text-lg"></i>
              iOS 下载
            </a>
          </div>

          <div className="text-background-50/60 text-sm">
            {downloadLinks.android.version} · {downloadLinks.android.size}
            <span className="mx-3">|</span>
            支持 Android 7.0+ · iOS 13+
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background-50 to-transparent h-32"></div>

      <div className="absolute bottom-[-60px] left-0 right-0 z-20">
        <div className="w-full max-w-5xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
            {stats.map((stat, index) => (
              <div
                key={stat.label}
                className="bg-background-50 rounded-xl p-4 md:p-5 text-center animate-fade-in-up"
                style={{ animationDelay: `${0.2 + index * 0.1}s` }}
              >
                <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center rounded-lg bg-primary-50">
                  <i className={`${stat.icon} text-primary-600 text-lg`}></i>
                </div>
                <div className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}